import './OnboardStep.scss'

import React, {Component} from 'react'
import { Button } from 'react-bootstrap'

import { push } from 'react-router-redux'

const OnboardStep = ({dispatch, pathname, children}) => {

  function handleClick() {
    dispatch(push({pathname: pathname}))
  }

  return (
    <div className="OnboardStep">
      <div className="OnboardStep__header">
        Neil Caldwell
      </div>
      <div className="OnboardStep__content">
      { children }
      </div>
      <div className="OnboardStep__button-row">
        <Button bsStyle="success" onClick={handleClick}>Next</Button>
      </div>
    </div>
  )
}

export default OnboardStep
